<template>
  <div class="container-fluid my-3 target" style="min-height:50vh">
    <div class="row">
      <div class="col-12">
        <div style="text-align:right">
          <button type="button" @click="downloadExcel" class="btn btn-success">下載報表</button>
          <button type="button" @click="download()" class="btn btn-danger mx-2">寄送報表</button>
        </div>
        <div class="d-flex justify-content-between">
          <div class="lesson-box box">
            課程名稱:{{this.courseName}}
          </div>
          <div class="group-box box">
            班級口說平均:{{this.avgScore}}分
          </div>
        </div>
        <div style="text-align:left">
          <span class="mr-3">出席人數: {{this.studentCount}}</span>
          <span>通過人數: {{this.passCount}}</span>
        </div>
      </div>
      <div class="col-12" style="min-height:40vh">
        <table class="rwd-table">
          <tbody>
            <tr>
              <th>學生姓名</th>
              <th>最近學習日期</th>
              <th>學習時間</th>
              <th>第一次成績</th>
              <th>練習次數</th>
              <th>口說成績</th>
            </tr>
            <tr v-for="(item, index) in lessonSummary" :key="index">
              <td class="rwd-td" data-th="學生姓名">
                {{item.name}}
              </td>
              <td data-th="最近學習日期">
                {{item.recent}}
              </td>
              <td data-th="學習時間">
                {{item.time}}
              </td>
              <td data-th="第一次成績">
                {{item.first_score}}
              </td>
              <td data-th="練習次數">
                {{item.finish_speak_count}}
              </td>
              <td data-th="口說成績"  v-if="item.score !== 'N/A'" class="pointer" style="text-decoration:underline" @click="goPage(item.student_id)">
                {{item.score}}
              </td>
              <td data-th="口說成績" style="color:#888" v-else>
                {{item.score}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination v-if="pageCount>1" class="m-auto pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
		</div>
  </div>
</template>
<script>
// @ is an alias to /src
// import Video from '@/components/Video.vue'
import Pagination from '@/components/Pagination.vue'
import api from '../../store/api'
export default {
  name: 'LessonSummary',
  data () {
    return {
      lessonSummary: [],
      record: {},
      avgScore: 0,
      courseName: '',
      studentCount: 0,
      passCount: 0,
      pageIndex: 1,
      pageCount: 0
    }
  },
  computed: {
    groupId () {
      return this.$route.params.groupId
    },
    lessonId () {
      return this.$route.params.lessonId
    }
  },
  mounted () {
    this.getLessonSummary()
  },
  methods: {
    async getLessonSummary() {
      const params = {
        page: this.pageIndex,
        pageSize: 10
      }
      const { data } = await api.get(`records/groups/${this.groupId}/voices/courses/${this.lessonId}`, { params })
      this.lessonSummary = data.data
      this.avgScore = data.avg_score
      this.courseName = data.course_name
      this.studentCount =  data.student_count
      this.passCount =  data.pass_count
      this.page = data.pageIndex
      this.pageCount = data.pageCount
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    export2Excel (list) {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../vendor/Export2Excel')
        const tHeader = [ '學生姓名', '最近學習日期', '學習時間', '第一次成績', '練習次數','口說成績' ]
        const filterVal = [ 'name', 'recent', 'time', 'first_score' , 'finish_speak_count', 'score', ]
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '學習紀錄')
      })
    },
    async downloadExcel () {
      const params = {
        page: this.pageIndex,
        pageSize: 1000
      }
      const { data } = await api.get(`records/groups/${this.groupId}/voices/courses/${this.lessonId}`, { params })
      this.export2Excel(data.data)
    },
    async download () {
      try {
        await api.get(`reports/groups/${this.groupId}/courses/${this.lessonId}/voices`)
        this.$swal({
          title: '報表計算完成後，將自動發送自您的信箱',
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
      } catch (error) {
        this.$swal({
          title: '目前報表功能異常，請聯絡管理者',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
      }
    },
    goPage (id) {
      this.$router.push({ name: 'VoiceRecord', params: { groupId: this.groupId, lessonId: this.lessonId, studentId: id } })
    },
    toPage (toPage) {
      this.pageIndex = toPage
      this.getLessonSummary()
    }
  },
  components: {
    Pagination
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/styles/color.scss";
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  th {
    overflow:hidden;
    border: 4px solid #fff;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }
  .th-title {
    width: 220px;
    height: 120px;
    padding: 0 !important;
    position: relative;
    img {
      top:0;
      left: -5px;
      position: absolute;
      width: 105%;
      height: 100%;
    }
  }
  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
  button  {
    display: none;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
